exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ui-calendar {\r\n    display: inherit !important;\r\n}\r\n\r\n.p-calendar {\r\n    padding: 0;\r\n}\r\n\r\n.ui-calendar > input {\r\n    display: block;\r\n    width: 100%;\r\n    height: 34px;\r\n    padding: 6px 12px;\r\n    font-size: 14px;\r\n    line-height: 1.428571429;\r\n    color: #555555;\r\n    vertical-align: middle;\r\n    background-color: #ffffff;\r\n    border: 1px solid #cccccc;\r\n    border-radius: 4px;\r\n    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);\r\n    transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Pablo/source/repos/prote/angular/src/app/shared/localized-calendar/localized-calendar.component.css
// module id = ../../../../../src/app/shared/localized-calendar/localized-calendar.component.css
// module chunks = 16